/**
 * Servicio de API para Dashboard
 */

import apiClient from './apiClient';

export interface DashboardStats {
    totalVehicles: number;
    soldVehicles: number;
    lastActivity: string | null;
}

interface ApiResponse<T> {
    success: boolean;
    data: T;
    message?: string;
}

export const dashboardService = {
    /**
     * Obtiene las estadísticas del dashboard
     */
    getStats: async (): Promise<DashboardStats> => {
        const response = await apiClient.get<ApiResponse<DashboardStats>>('/dashboard');
        return response.data.data;
    },
};

export default dashboardService;
